import React from "react";

import { Msg, Checkbox } from "@shared/components";

import { Caution } from "../caution/Caution";

interface CautionStepProps {
  onTermsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CautionStep = ({ onTermsChange }: CautionStepProps) => {
  return (
    <div className="code-editor-exam-detail__caution-step">
      <Caution />
      <div className="code-editor-exam-detail__caution-step__terms-container">
        <Checkbox onChange={onTermsChange}>
          <Msg id="editor-exam-detail.agreement" />
        </Checkbox>
      </div>
    </div>
  );
};
